import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../../components/hooks/useFetch.js';
import InputDelegacao from '../../../../components/form/InputDelegacao.js';
import Input from '../../../../components/form/Input.js';
import SelectPerfil from '../../../../components/form/SelectPerfil.js';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './TelaPermitirTerceiroDelegar.scss';
import { getIPAddress } from '../../../../components/utils/GetIPAddress.js';
import {
  PERMISSIONARIO_PESQUISAR_IDCORREIOS,
  PERMISSIONARIO_PESQUISAR,
  PERMISSIONARIO_INCLUIR,
  PERMISSIONARIO_EXCLUIR,
} from '../../../../services/delegacaoTerceiro.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import useModalConfirmacao from '../../../../components/hooks/useModalConfirmacao.js';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import FormPermissaoSistema from './FormPermissaoSistema.js';
import FormPermissaoContrato from './FormPermissaoContrato.js';

const TelaPermitirTerceiroDelegar = () => {
  const methods = useForm({});
  const [ipAddress, setIpAddress] = useState('');
  const location = useLocation();
  const dados = location.state;
  const { request: requestUsuario, data: dadosUsuario } = useFetch();
  const { request: requestPermissionario, data: dadosPermissionario } =
    useFetch();
  const [usuarioIncluir, setUsuarioIncluir] = useState();
  const [usuario, setUsuario] = useState();
  const [perfil, setPerfil] = useState();
  const [itensMarcados, setItensMarcados] = useState([]);
  const [selecionados, setSelecionados] = useState(0);
  const [pesquisar, setPesquisar] = useState(true);
  const [pesquisarMeuCorreios, setPesquisarMeuCorreios] = useState(true);
  const [terceiro, setTerceiro] = useState();
  const { abreModalConfirmacao } = useModalConfirmacao();
  const [modalAbertoSistemas, setModalAbertoSistemas] = useState(false);
  const [modalAbertoContratos, setModalAbertoContratos] = useState(false);

  const { request } = useFetch();
  useEffect(() => {
    if (
      dadosPermissionario &&
      dadosPermissionario.length !== itensMarcados.length
    )
      setItensMarcados(dadosPermissionario.map(() => false));
  }, [dadosPermissionario, itensMarcados.length]);
  const navigate = useNavigate();
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  useEffect(() => {
    requestPermissionario(PERMISSIONARIO_PESQUISAR(dados.idCorreios));
    setPesquisar(false);
  }, [pesquisar]);
  useEffect(() => {
    if (usuario != '' && usuario != undefined && pesquisarMeuCorreios)
      requestUsuario(PERMISSIONARIO_PESQUISAR_IDCORREIOS(usuario));
    setPesquisarMeuCorreios(false);
  }, [pesquisarMeuCorreios]);
  useEffect(() => {
    if (dadosUsuario) {
      const dadosGuardar = { ...dadosUsuario, perfil: perfil };
      setUsuarioIncluir(dadosGuardar);
    }
  }, [dadosUsuario]);
  const excluirUsuario = (item) => {
    abreModalConfirmacao(
      `Usuário(a) ${item.nomePF} será removido(a). Confirma ?`,
      () => excluiUsuario(item),
    );
  };
  const excluiUsuario = async (item) => {
    const lista = [];
    lista[0] = item.idCorreiosPF;
    const { response } = await request(
      PERMISSIONARIO_EXCLUIR(dados.idCorreios, lista, dados.tipo, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog('Usuário excluído com sucesso.');
      setPesquisar(true);
    }
  };
  const excluirUsuarios = () => {
    if (isCheckedSelecionaTodos) {
      abreModalConfirmacao(`Todos terceiros serão removidos. Confirma ?`, () =>
        excluiTodosUsuarios(),
      );
    } else {
      const marcados = itensMarcados.filter((item) => item === true).length;
      if (marcados === 0) {
        abreAlertaDialog('Não foi selecionado nenhum terceiro');
        return;
      }
      var msg;
      if (marcados > 1) {
        msg = 'Os terceiros selecionados serão removidos. Confirma ?';
      } else {
        msg = 'O terceiro selecionado será removido. Confirma ?';
      }
      abreModalConfirmacao(msg, () => excluiUsuariosSelecionados());
    }
  };
  const excluiTodosUsuarios = async () => {
    const idCorreiosExcluir = dadosPermissionario.map(
      (excluir) => excluir.idCorreiosPF,
    );
    const { response } = await request(
      PERMISSIONARIO_EXCLUIR(
        dados.idCorreios,
        idCorreiosExcluir,
        dados.tipo,
        ipAddress,
      ),
    );
    if (response.ok) {
      abreAlertaDialog('Usuários excluídos com sucesso.');
      setPesquisar(true);
      setIsCheckedSelecionaTodos(false);
    }
  };

  const excluiUsuariosSelecionados = async () => {
    const idCorreiosExcluir = dadosPermissionario
      .filter((_, index) => itensMarcados[index])
      .map((dadosPermissionario) => dadosPermissionario.idCorreiosPF);
    const { response } = await request(
      PERMISSIONARIO_EXCLUIR(
        dados.idCorreios,
        idCorreiosExcluir,
        dados.tipo,
        ipAddress,
      ),
    );
    if (response.ok) {
      abreAlertaDialog('Usuário(s) excluído(s) com sucesso.');
      setPesquisar(true);
    }
  };
  const incluirUsuario = async (usuario) => {
    const dadosEnviar = {
      idCorreios: dados.idCorreios,
      idCorreiosPF: usuarioIncluir.idCorreios,
      perfil: usuarioIncluir.perfil,
      tipo: dados.tipo,
    };
    const { response } = await request(
      PERMISSIONARIO_INCLUIR(dadosEnviar, ipAddress),
    );
    if (response.ok) {
      if (usuarioIncluir.perfil === 'S') {
        abreAlertaDialog(
          'Usuário incluído com sucesso! Não esqueça de selecionar os sistemas e contratos que o supervisor deve possuir permissão.',
        );
      } else {
        abreAlertaDialog('Usuário incluído com sucesso!');
      }
      requestPermissionario(PERMISSIONARIO_PESQUISAR(dados.idCorreios));
      setPesquisar(true);
      setUsuarioIncluir();
    }
  };
  const incluirUsuarioDelegar = () => {
    if (
      methods.getValues('usuario').trim() == '' ||
      methods.getValues('usuario') == undefined
    ) {
      abreAlertaDialog('Favor informar o CPF(somente números) ou usuário');
      return;
    }
    if (
      methods.getValues('perfil').trim() == '' ||
      methods.getValues('perfil') == undefined
    ) {
      abreAlertaDialog('Favor informar o Perfil');
      return;
    }
    setUsuario(methods.getValues('usuario'));
    setPerfil(methods.getValues('perfil'));
    document.getElementById('usuario').value = '';
    document.getElementById('perfil').value = '';
    setPesquisarMeuCorreios(true);
  };
  const handleCheckBoxChange = (id) => {
    const atualizaItensMarcados = [...itensMarcados];
    atualizaItensMarcados[id] = !atualizaItensMarcados[id];
    setItensMarcados(atualizaItensMarcados);
  };
  useEffect(() => {
    const marcados = itensMarcados.filter((item) => item === true).length;
    setSelecionados(marcados);
  }, [itensMarcados]);

  const [isCheckedSelecionaTodos, setIsCheckedSelecionaTodos] = useState(false);
  const handleSelecionaTodos = () => {
    setIsCheckedSelecionaTodos(!isCheckedSelecionaTodos);
  };
  useEffect(() => {
    const marcados = itensMarcados.filter((item) => item === true).length;
    if (isCheckedSelecionaTodos) {
      const todosSelecionados = itensMarcados.map(() => true);
      setItensMarcados(todosSelecionados);
    } else {
      const todosSelecionados = itensMarcados.map(() => false);
      setItensMarcados(todosSelecionados);
    }
  }, [isCheckedSelecionaTodos]);
  const abrirModalSistema = (id) => {
    setTerceiro(dadosPermissionario[id]);
    setModalAbertoSistemas(true);
  };

  const abrirModalContrato = (id) => {
    setTerceiro(dadosPermissionario[id]);
    setModalAbertoContratos(true);
  };

  const cancelar = () => {
    setModalAbertoSistemas(false);
    setModalAbertoContratos(false);
    setPesquisar(true);
  };
  return (
    <div className="conteudo delegacao-terceiro">
      <h1>Delegação de terceiros</h1>

      <div className="adicionar-terceiro-container">
        <h6>Adicionar terceiro:</h6>

        <div className="campo-txt">
          <label className="subtitulo-p" htmlFor="txt-input">
            CPF ou usuário:
          </label>
          <div className="input-container input-com-ic">
            <i className="ic-usuario input-ic"></i>
            <InputDelegacao
              type="text"
              id="usuario"
              name="usuario"
              title="Digite o CPF ou o Usuário(nickname)"
              placeholder="Digite o CPF ou o Usuário(nickname)"
              {...formMethods}
            />
          </div>
          <div className="legenda mensagem"></div>
        </div>
        {dados.tipo === 'PJ' ? (
          <SelectPerfil id="perfil" label="Perfil" {...formMethods} />
        ) : (
          <SelectPerfil
            id="perfil"
            label="Perfil"
            tipo="adm"
            {...formMethods}
          />
        )}
        <button
          type="button"
          className="btn-pre com-icone btn-pesquisar"
          onClick={() => incluirUsuarioDelegar()}
        >
          <i className="ic-lupa"></i>
          Pesquisar
        </button>
        <p id="info-perfil" className="legenda">
          Um <b>Supervisor</b> tem permissão para delegar acesso apenas aos
          sistemas e contratos que você autorizar. Não esqueça, é necessário
          selecionar os sistemas e contrato que o supervisor terá permissão de
          delegação.
        </p>
        <hr />
        {usuarioIncluir && (
          <>
            <div className="celula-info">
              <p className="mini">CPF / Usuário</p>
              <p className="small">{usuarioIncluir.idCorreiosPF}</p>
            </div>
            <div className="celula-info">
              <p className="mini">Nome</p>
              <p className="small">{usuarioIncluir.nomePF}</p>
            </div>
            <button
              id="btn-adicionar"
              className="btn-pre"
              onClick={() => incluirUsuario(usuarioIncluir)}
            >
              <i className="ic-usuario-adicionar"></i>Adicionar terceiro
            </button>
          </>
        )}
      </div>
      {dadosPermissionario?.length > 0 ? (
        <>
          <h6>Relação de terceiros:</h6>

          <div className="lista-terceiros">
            <div className="selecao">
              <Input
                id="selecionarTodos"
                name="selecionarTodos"
                className="input-checkbox"
                type="checkbox"
                onClick={handleSelecionaTodos}
                checked={isCheckedSelecionaTodos}
                {...formMethods}
              />

              <div className="legenda">
                {selecionados} terceiro(s) selecionado(s)
              </div>

              <button
                className="btn-txt so-icone"
                onClick={() => excluirUsuarios()}
              >
                <i className="ic-lixo"></i>
              </button>
            </div>

            {dadosPermissionario?.map((item, index) => (
              <div className="permissao-terceiro card bg-superficie">
                <Input
                  className="input-checkbox"
                  type="checkbox"
                  name="selecionado"
                  onChange={() => handleCheckBoxChange(index)}
                  checked={itensMarcados[index] || false}
                  {...formMethods}
                />

                <label className="celula-info" htmlFor="">
                  <p className="mini">Nome</p>
                  <p className="pequeno">{item.nomePF}</p>
                </label>

                <div className="celula-info">
                  <p className="mini">CPF / Usuário</p>
                  <p className="pequeno">
                    {item.cpfFormatado ?? item.idCorreiosPF}
                  </p>
                </div>

                <div className="celula-info">
                  <p className="mini">Perfil</p>
                  <p className="pequeno">{item.perfil}</p>
                </div>

                <div className="celula-info">
                  <p className="mini">Sistemas</p>
                  <p className="pequeno">
                    {item.perfil == 'Administrador'
                      ? 'Todos'
                      : item?.sistemas
                      ? item?.sistemas?.length
                      : '0'}
                  </p>
                </div>
                <div className="celula-info">
                  <p className="mini">Contratos</p>
                  <p className="pequeno">
                    {item.perfil == 'Administrador'
                      ? 'Todos'
                      : item?.contratos
                      ? item?.contratos?.length
                      : '0'}
                  </p>
                </div>

                <div className="acoes-usuario btns-row">
                  {item.perfil === 'Supervisor' && (
                    <>
                      <button
                        title="editar sistemas"
                        className="btn-txt so-icone"
                        onClick={() => abrirModalSistema(index)}
                      >
                        <i className="ic-monitor"></i>
                      </button>
                      <button
                        title="editar contratos"
                        className="btn-txt so-icone"
                        onClick={() => abrirModalContrato(index)}
                      >
                        <i className="ic-contrato"></i>
                      </button>
                    </>
                  )}
                  <button
                    title="excluir terceiro"
                    className="btn-txt so-icone"
                    onClick={() => excluirUsuario(item)}
                  >
                    <i className="ic-lixo"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p
          style={{
            backgroundColor: '#f0f0f0',
            padding: '1rem',
            textAlign: 'center',
            borderRadius: '6px',
            fontStyle: 'italic',
            color: '#555',
          }}
        >
          Adicione um terceiro.
        </p>
      )}
      <div className="btns-row">
        <button className="btn-pre" onClick={() => navigate('/principal')}>
          Voltar
        </button>
      </div>
      <ModalDialog
        titulo="Permissão Sistemas"
        id="modalSistema"
        aberto={modalAbertoSistemas}
        setAberto={setModalAbertoSistemas}
        opcaoFechar={false}
      >
        <FormPermissaoSistema
          acaoCancelar={() => cancelar()}
          dados={dados}
          terceiro={terceiro}
        />
      </ModalDialog>
      <ModalDialog
        titulo="Permissão Contratos"
        id="modalContrato"
        aberto={modalAbertoContratos}
        setAberto={setModalAbertoContratos}
        opcaoFechar={false}
      >
        <FormPermissaoContrato
          acaoCancelar={() => cancelar()}
          dados={dados}
          terceiro={terceiro}
        />
      </ModalDialog>
    </div>
  );
};
export default TelaPermitirTerceiroDelegar;
